<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Autoren und Zitierhinweise</h4>
    </div>
  </div>
  <mat-card>
    <h6>
      Bitte nutzen Sie die folgende Zitierweise, wenn Sie die
      <b>gesamte Literaturdatenbank</b> Tierwohlindikatoren zitieren möchten:
    </h6>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Projektkonsortium Nationales Tierwohl-Monitoring (NaTiMon) 2021:
        Literaturdatenbank Tierwohlindikatoren [online]. Darmstadt, Deutschland:
        Kuratorium für Technik und Bauwesen in der Landwirtschaft (KTBL), zu
        finden in
        www.ktbl.de/webanwendungen/literaturdatenbank-tierwohlindikatoren
        [zitiert am - Datum]
        <br />
        Kurzform: NaTiMon (2021)
      </div>
      <div class="column-zweispaltig img-container-zentriert"></div>
    </div>
    <br />
    <h6>
      Bitte stellen Sie der oben aufgeführten Zitation die folgenden Autorinnen und Autoren voran, wenn Sie <b>einzelne Indikatoren</b> zitieren möchten:
    </h6>
    <br />
    <h5><b>Aquakultur:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
  <h6>Bei Indikatoren mit <b>gerader</b> Identifikationsnummer nutzen Sie
        bitte folgende Zitierweise:</h6>
        Lugert, V.; Retter, K.; Teitge, F.; Steinhagen, D.; Reiser, S. (2021):
        Tierwohlindikatoren Aquakultur – Haltung, Transport und Schlachtung.
        <br />
        <br />
   <h6>     Bei Indikatoren mit <b>ungerader</b> Identifikationsnummer nutzen Sie
        bitte folgende Zitierweise:
      </h6>
        Retter, K.; Lugert, V.; Teitge, F.; Reiser,
        S.; Steinhagen, D. (2021): Tierwohlindikatoren Aquakultur – Haltung,
        Transport und Schlachtung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Thuenen_Institut.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
        <img
          src="assets/img/Logo_Tieraerztliche_HS_Hannover.png"
          alt="Tieraerztliche_HS_Hannover"
          class="img"
          height="152.89px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Geflügel - Haltung:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Redantz, A.; Andersson, R. (2021): Tierwohlindikatoren Geflügel -
        Haltung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_HS_Osnabrueck.png"
          alt="HS-Osnabrueck"
          class="img"
          height="104.89px"
          style="float: left"
        />
      </div>
    </div>
    <br />
    <h6>
      Bei Indikatoren mit der <b>Quelle „Destatis“</b> nutzen Sie bitte folgende
      Zitierweise:
    </h6>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Heil, N.; Redantz, A.; Andersson, R.; Koch, M. (2021):
        Tierwohlindikatoren Geflügel - Haltung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Statistisches_Bundesamt.png"
          alt="Statistisches_Bundesamt"
          class="img"
          height="78.23px"
          style="float: left"
        />
        <img
          src="assets/img/Logo_HS_Osnabrueck.png"
          alt="HS-Osnabrueck"
          class="img"
          height="104.89px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Rind - Haltung:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Frieten, D.; Brinkmann, J.; March, S. (2021): Tierwohlindikatoren Rind -
        Haltung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Thuenen_Institut.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
      </div>
    </div>
    <br />
    <h6>
      Bei Indikatoren mit der <b>Quelle „Destatis“</b> nutzen Sie bitte folgende
      Zitierweise:
    </h6>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Heil, N.; Frieten, D.; Brinkmann, J.; March, S.; Koch, M. (2021):
        Tierwohlindikatoren Rind - Haltung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Statistisches_Bundesamt.png"
          alt="Statistisches_Bundesamt"
          class="img"
          height="78.23px"
          style="float: left"
        />
        <img
          src="assets/img/Logo_Thuenen_Institut.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Schaf und Ziege – Haltung, Transport und Schlachtung:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Bielicke, M.; Simantke, C.; Hillman, E. (2021): Tierwohlindikatoren Schaf und Ziege - Haltung, Transport und Schlachtung.  
        <br />
        bzw.
        <br />
        Simantke, C.; Bielicke, M.; Hillman, E. (2021): Tierwohlindikatoren Schaf und Ziege - Haltung, Transport und Schlachtung.  
        
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_HU_Berlin.png"
          alt="Humboldt Universität zu Berlin"
          class="img"
          height="152.89px"
          style="float: left"
        />
      </div>
    </div>
    <br />
    <h6>
      Bei Indikatoren mit der <b>Quelle „Destatis“</b> nutzen Sie bitte folgende
      Zitierweise:
    </h6>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Heil, N.; Bielicke, M.; Simantke, C.; Hillman, E.; Koch, M. (2021): Tierwohlindikatoren Schaf und Ziege - Haltung, Transport und Schlachtung.  
        <br />
        bzw.
        <br />
        Heil, N.; Simantke, C.; Bielicke, M.; Hillman, E.; Koch, M. (2021): Tierwohlindikatoren Schaf und Ziege - Haltung, Transport und Schlachtung.  
        
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Statistisches_Bundesamt.png"
          alt="Statistisches_Bundesamt"
          class="img"
          height="78.23px"
          style="float: left"
        />
        <img
          src="assets/img/Logo_HU_Berlin.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
      </div>
    </div>














    <br />
    <h5><b>Schwein - Haltung:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Krugmann, K.; Krieter, J. (2021): Tierwohlindikatoren Schwein - Haltung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_CAU.png"
          alt="CAU"
          class="img"
          height="109.34px"
          style="float: left"
        />
      </div>
    </div>
    <br />
    <h6>
      Bei Indikatoren mit der <b>Quelle „Destatis“</b> nutzen Sie bitte folgende
      Zitierweise:
    </h6>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Heil, N.; Krugmann, K.; Krieter, J.; Koch, M. (2021):
        Tierwohlindikatoren Schwein - Haltung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Statistisches_Bundesamt.png"
          alt="Statistisches_Bundesamt"
          class="img"
          height="78.23px"
          style="float: left"
        />
        <img
          src="assets/img/Logo_CAU.png"
          alt="CAU"
          class="img"
          height="109.34px"
          style="float: left"
        />
      </div>
    </div>
    <br />

    <h5><b>Tierwohl-Begleitindikatoren:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Gröner, C.; Johns, J.; Treu, H.; Bergschmidt, A. (2021):
        Tierwohl-Begleitindikatoren.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Thuenen_Institut.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Transport und Schlachtung Rind, Schwein und Geflügel:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Kernberger-Fischer, I.; Marahrens, M.; Schrader, L. (2021):
        Tierwohlindikatoren Rind, Schwein und Geflügel – Transport und
        Schlachtung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_FLI.png"
          alt="FLI"
          class="img"
          height="107.54px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h6>
      Bei Indikatoren mit der <b>Quelle „Destatis“</b> nutzen Sie bitte folgende
      Zitierweise:
    </h6>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Heil, N.; Kernberger-Fischer, I.; Marahrens, M.; Schrader, L.; Koch, M.
        (2021): Tierwohlindikatoren Rind, Schwein und Geflügel – Transport und
        Schlachtung.
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Statistisches_Bundesamt.png"
          alt="Statistisches_Bundesamt"
          class="img"
          height="78.23px"
          style="float: left"
        />
        <img
          src="assets/img/Logo_FLI.png"
          alt="FLI"
          class="img"
          height="107.54px"
          style="float: left"
        />
      </div>
    </div>

    <br />
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon [icon]="faArrowLeft" class="mx-1 icon-arrow"></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
